import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-archives",
  "use": "icon-archives-usage",
  "viewBox": "0 0 1265 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1265 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-archives\"><defs><style type=\"text/css\"></style></defs><path d=\"M169.307154 313.434609v-1.033996H99.34014v635.696474h69.967014V313.434609zM1168.108306 144.414675V85.936497H101.714499v158.679981h69.967015V144.414675h996.426792zM69.986163 227.498111v-1.033995H0v635.715621h69.986163V227.498111z\" p-id=\"5732\" /><path d=\"M1068.768166 58.497326V0H2.37436v158.699129h69.986162V58.497326h996.407644zM198.87176 388.284379v635.715621h1066.393807v-635.715621H198.87176zM1195.279405 172.141067H198.87176v157.645986h996.407645v1.053143h69.986162V172.141067h-69.986162z\" p-id=\"5733\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/archives.svg
// module id = PZ7j
// module chunks = 77